

















import {Component, Prop, Vue} from "vue-property-decorator";
import {CustomerStore} from "@/modules/customers/store";
import {Customer} from "@/interfaces/entity";

@Component({
    name: "CustomerTableAction"
})
export default class extends Vue {
    @Prop({ required: true, type: String })
    readonly customerId!: string;

    get customer(): Customer {
        return CustomerStore.data[this.customerId];
    }

    set customer(value: Customer) {
        CustomerStore.data[this.customerId] = value;
    }
    async onConfirm() {
        try {
            await CustomerStore.deleteCustomer(this.customerId);
            this.$notification.success({
                message: "Thành công",
                description: "Xóa khách hàng thành công"
            });
        } catch (e) {
            console.log(e);
            this.$notification.error({
                message: "Thất bại",
                description: "Xóa khách hàng thất bại"
            });
        }
    }
}
